import { boolean, object } from "yup";

export const contentWriterFormSchema = object().shape({
    adminPanelAccess: boolean().required("required"),
    editingAccess: boolean().required("required"),
});
